import { render, staticRenderFns } from "./PdokCapacity.vue?vue&type=template&id=4bf7ce9b"
import script from "./PdokCapacity.vue?vue&type=script&lang=js"
export * from "./PdokCapacity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports